import { render, staticRenderFns } from "./convenientEntrance.vue?vue&type=template&id=1c42bbb8&scoped=true"
import script from "./convenientEntrance.vue?vue&type=script&lang=js"
export * from "./convenientEntrance.vue?vue&type=script&lang=js"
import style0 from "./convenientEntrance.vue?vue&type=style&index=0&id=1c42bbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42bbb8",
  null
  
)

export default component.exports